// extracted by mini-css-extract-plugin
export default {"Text":"column-settings-saved-message-module__Text--IDVjW"};